import React, { useState } from "react";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  CssBaseline,
  Paper,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import louca_logo from "../../../assets/Images/louca_logo.png";
import { apiCallSignIn, postApiSignInVenue } from "../../../Core/Apicall";
import { useNavigate } from "react-router-dom";
import { setToken,setProfileData } from "../../../Redux/Reducers/GlobalVar";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [role, setRole] = useState("admin");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: false,
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleRoleChange = (event: React.SyntheticEvent, newValue: string) => {
    setRole(newValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const getDeviceType = () => {
    const ua = navigator.userAgent || navigator.vendor
    if (/android/i.test(ua)) return "Android";
    if (/iPad|iPhone|iPod/.test(ua)) return "IOS";
    if (/Windows NT|Macintosh|Linux|CrOS/i.test(ua)) return "Web";
    return "Other";
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {

      const data = {
        emailId: formData.email,
        password: formData.password,
        deviceType: getDeviceType()
      };
      let res
      if (role == "admin") {
        res = await apiCallSignIn(data);
      } else {
        res = await postApiSignInVenue(data);
      }
      console.log("resresres",res);
      
      const token: any = res;
      dispatch(setToken(token));
      dispatch(setProfileData(res.data));
      navigate("/admin/Dashboard");
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper
        elevation={6}
        sx={{
          p: 4,
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={louca_logo} alt="louca_logo" />
        <Typography component="h1" variant="h5">
          Login
        </Typography>

        <Tabs
          value={role}
          onChange={handleRoleChange}
          sx={{ mt: 2, width: '100%' }}
          variant="fullWidth"
        >
          <Tab value="admin" label="Admin" />
          <Tab value="venue" label="Venue Owner" />
        </Tabs>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={formData.email}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="remember"
                checked={formData.remember}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Remember me"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
          >
            Sign In as {role === "admin" ? "Admin" : "Venue Owner"}
          </Button>

          <Grid container>
            <Grid size={12}>
              <Link
                href="/admin/ForgotPassword"
                style={{ color: "black", textDecoration: "none" }}
                variant="body2"
              >
                Forgot password?
              </Link>
            </Grid>
          </Grid>

          {/* Register Link - Only for Venue Owner */}
          {role === "venue" && (
            <Grid container sx={{ mt: 2 }}>
              <Grid size={12} sx={{ textAlign: "center" }}>
                <Typography variant="body2" color="text.secondary">
                  Don't have an account?{" "}
                  <Link
                    href="/venue-owner/register"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      fontWeight: "bold"
                    }}
                  >
                    Register
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          )}
        </Box>
      </Paper>
    </Container>
  );
}